// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__satoshi_4443ec', '__satoshi_Fallback_4443ec'","fontStyle":"normal"},"className":"__className_4443ec","variable":"__variable_4443ec"};